'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('community-edit', {
      url: '/community/edit/:id',
      template: '<community-edit></community-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/community-edit/community-edit.routes.js